import React, { useState, useEffect } from 'react'
import { Container, SwitchButton, Typography } from '@cleartrip/ct-design-components'
import Emi from '@/assets/svg/Emi'
import { Stencil } from '@/components/common/Stencil'
import BadgeGradientSvg from './BadgeGradientSvg'
import dynamic from 'next/dynamic'
import { isServer } from '@/utils/general'
import { ravenSDKSrpCfwTrigger } from '@/analytics/raven/ravenSDKHelper'
import { getSrpSearchData } from '@/redux/slices/srpSlice'
import { useAppSelector } from '@/redux/store/hooks'
const DotLottiePlayer = dynamic(() => import("@dotlottie/react-player").then(mod => mod.DotLottiePlayer), {
    ssr: false,
    loading: () => <></>
})
const LottieAnimation = () => {
    const [leftPlaying, setLeftPlaying] = useState(false)
    const [rightPlaying, setRightPlaying] = useState(false)

    useEffect(() => {
        const leftFireworkTimer = setTimeout(() => {
            setLeftPlaying(true)
        }, 2000)
        
        const rightFireworkTimer = setTimeout(() => {

            setRightPlaying(true)
        }, 3000)

        return () => {
            clearTimeout(leftFireworkTimer)
            clearTimeout(rightFireworkTimer)
        }
    }, [])
    if (isServer()) {
        return null
    }
    return (
        <>
            {leftPlaying && (
                <DotLottiePlayer 
                    src={"https://static-assets-ct.flixcart.com/ct/assets/resources/images/Fireworks_right.lottie"}
                    autoplay
                    style={{height: '30px', width: '70px', position: 'absolute', left: '215px', top: '-25px'}}
                    onEvent={(event) => {
                        if (event === 'complete') {
                            setLeftPlaying(false)
                        }
                    }}
                />
            )}
            
            {rightPlaying && (
                <DotLottiePlayer 
                    src={"https://static-assets-ct.flixcart.com/ct/assets/resources/images/Fireworks_right.lottie"}
                    autoplay
                    style={{height: '30px', width: '70px', position: 'absolute', right: '215px', top: '-25px', transform: 'scaleX(-1)'}}
                    onEvent={(event) => {
                        if (event === 'complete') {
                            setRightPlaying(false)
                        }
                    }}
                />
            )}
        </>
    )
}

const EmiCallout = ({
    noCostEmi = { enabled: true },
    showEmi = false,
    setShowEmi,
    showPrimaryCallout = true,
    showSecondaryCallout = false,
    viewBanksClick = () => {},
    isDomesticRt = false,
    sortedFilteredCardIds = {},
    resultsData = {},
    loadEmiCallout = false,
    getEmiCalloutPayload = () => {},
    setIsCustomisedEmi = () => {}, 
    emiCalloutMsg = { data: {}, isLoading: false, loaded: true },
    isLoading = false,
    setShowAnimation,
    processedData = {}
}) => {
    const { searchData } = useAppSelector(getSrpSearchData)
    const showLoader = isLoading || (emiCalloutMsg?.isLoading && !emiCalloutMsg?.loaded)
    
    const toggleEmiSwitch = () => {
        const newEmiState = !showEmi
        !showEmi && setShowAnimation(true)
        setShowEmi(newEmiState)
        
        // Raven event for EMI toggle
        if (searchData && processedData) {
            const actionName = newEmiState ? 'srp_emi_toggle_on' : 'srp_emi_toggle_off'
            ravenSDKSrpCfwTrigger('a_ui_action', searchData, processedData, {
                action_name: actionName,
                action_type: 'click',
                property: 'srp_page'
            })
        }
    }
    if (!showPrimaryCallout && !showSecondaryCallout) {
        return null
    }

    if (showLoader) {
        return (
            <Container className='flex flex-middle py-4 mb-3'>
                <Stencil shimmer height="56px" width="100%" borderRadius="16px"/>
            </Container>
        )
    }

    return (
        <Container className='emi-callout-wrapper mb-3'>
            <Container className='emiOuterContainer'>
                <Container className='emiNewContainer__layer0'>
                    <Container className='emiNewContainer__layer1'>
                        <Container className='emiNewContainer__layer2'>
                            <Container className="emiTextContainer">
                                <Typography className="celebration-text" as='p'>
                                    Big Vacation, Small Payments!
                                </Typography>
                                <Container className="emiTextContainer__svgContainer">
                                    <BadgeGradientSvg width='16' height='28' />
                                </Container>
                                <LottieAnimation />
                            </Container>
                            
                            <Container className='emiActionsContainer'>
                                <Container className='emi-left-content'>
                                    {!isDomesticRt && (
                                        <Container className='emi-icon'>
                                            <Emi />
                                        </Container>
                                    )}
                                    <Container className='emi-main-text'>
                                        {showPrimaryCallout && (noCostEmi.enabled ? 'View No Cost EMI Prices' : 'View EMI prices')}
                                        {showSecondaryCallout && 'Book travel via No Cost EMI'}
                                    </Container>
                                    
                                    <Container className='emi-divider' />
                                    <Container className='emi-sub-text'>
                                        Now pay in easy installments through Credit Card EMI
                                    </Container>
                                </Container>

                                {showPrimaryCallout && (
                                    <Container className='emi-toggle'>
                                        <SwitchButton
                                            checked={showEmi}
                                            onChange={toggleEmiSwitch}
                                            size="large"
                                            iconVisibility
                                            disabled={showSecondaryCallout}
                                        />
                                    </Container>
                                )}

                                {showSecondaryCallout && (
                                    <Container className='emi-view-banks' onClick={viewBanksClick}>
                                        <Typography as='span'>View Banks</Typography>
                                    </Container>
                                )}
                            </Container>
                        </Container>
                    </Container>
                </Container>
            </Container>
        </Container>
    )
}

export default EmiCallout